module.exports = __webpack_public_path__ + "static/media/gray-down-arrow.811e5f4a.svg";